module.exports = __webpack_public_path__ + "img/flower_leaf_10.c1549465.png";